/**
 * Paths where an expired-trial coach is not blocked by the subscription modal
 * (marketing, auth, signup flow, subscribe page, public pages).
 */
export function isCoachTrialExemptPath(pathname) {
  if (pathname === "/" || pathname === "") return true;
  const exempt = [
    "/pricing",
    "/about",
    "/coach-subscription",
    "/login",
    "/set-password",
    "/callback",
    "/coaching",
    "/privacy-policy",
    "/support",
    "/client-intake",
    "/payment",
  ];
  for (const p of exempt) {
    if (pathname === p || pathname.startsWith(`${p}/`)) return true;
  }
  if (pathname.startsWith("/coaches/")) return true;
  return false;
}
